
( () => {
  // Navigation toggle
  const header = document.querySelector( '.header' );

  if ( !header ) {
    return;
  }

  const header_toggle = header.querySelector( '.header__button' );
  const header_block = header.querySelector( '.header__main' );

  header_toggle.addEventListener( 'click', () => {
    header_toggle.classList.toggle( 'toggled', !header_toggle.classList.contains( 'toggled' ) );
    header_block.classList.toggle( 'toggled', !header_block.classList.contains( 'toggled' ) );
    header.classList.toggle( 'toggled', !header.classList.contains( 'toggled' ) );
  } );
} )();

( () => {
  // Toggle fact boxes
	window.addEventListener( 'click', ( event ) => {
		if ( event.target.classList.contains( 'fact__button' ) ) {
			event.target.parentElement.classList.toggle( 'fact--expanded' );
		}
	} );
} )();

( () => {
  // Toggle filters
	window.addEventListener( 'click', ( event ) => {
		if ( event.target.classList.contains( 'filter__toggle' ) ) {
			event.target.parentElement.classList.toggle( 'filter--expanded' );
		}
	} );
} )();

( () => {
  // Toggle accordion items
	window.addEventListener( 'click', ( event ) => {
    if ( event.target.classList.contains( 'accordion-item__toggle' ) ) {
      event.target.parentElement.classList.toggle( 'toggled' );
		}
	} );
} )();

( () => {
  // Handle subnavs
  const header_list = document.querySelector( '.header__list--main' );

  if ( !header_list ) {
    return;
  }

  const header_links = document.querySelectorAll( '.header__link--has-subnav' );
  header_links.forEach( element => {
    element.addEventListener( 'click', () => {
      // A links parent element is assigned a "toggled" class to reveal the subnav,
      // so if the elements parent doesn't currently have that class, we should
      // open this subnav.
      if ( !element.parentElement.classList.contains( 'toggled' ) ) {
        closeAllSubnavs();
        header_list.classList.add( 'subnav-open' ); // used for x-axis repositioning of nav drawer on small screens
        element.parentElement.classList.add( 'toggled' );
        element.nextElementSibling.focus();
      // Otherwise, we can determine that the user is clicking an already open
      // subnav link, and as such we should close the dropdown in question.
      } else if ( element.parentElement.classList.contains( 'toggled' ) ) {
        header_list.classList.remove( 'subnav-open' );
        element.parentElement.classList.remove( 'toggled' );
      }
    } );
  } );

  window.addEventListener( 'click', ( event ) => {
    if ( event.target.classList.contains( 'header__subnav-close' ) ) {
      closeAllSubnavs();
      header_list.classList.remove( 'subnav-open' );
    }
  } );

  function closeAllSubnavs() {
    const all_subnavs = document.querySelectorAll( '.header__has-subnav.toggled' );
    for ( let i = 0; i < all_subnavs.length; i++ ) {
      all_subnavs[i].classList.remove( 'toggled' );
    }
  }
} )();

( () => {
  const shareButtons = document.querySelectorAll( '.share-button' );

  if (!shareButtons) {
    return;
  }

  shareButtons.forEach(element => {
    // Share must be triggered by 'user activation'
    element.addEventListener('click', event => {
      if (navigator.share) {
        navigator.share({
          title: document.title,
          url: document.location.href
        })
        .catch(console.error);
      } else {
        navigator.clipboard.writeText(document.location.href);
        element.querySelector('span').innerHTML = "Link copied!";
      }
    });
  });
} )();
